<template>
  <div>
    <div
      id="offcanvasChapters"
      class="offcanvas offcanvas-xl offcanvas-end offcanvas-end--filters d-flex"
      :class="{ show: visible }"
      :style="{ visibility: visible ? 'visible' : 'hidden' }"
      tabindex="-1"
      aria-labelledby="offcanvasFiltersLabel"
    >
      <div class="offcanvas-header">
        <h3
          id="offcanvasResearchLineLabel"
          class="offcanvas-title"
        >
          <span class="btn btn-icon btn-icon rounded-circle btn-flat-secondary bg-light-secondary me-2"><i data-feather="settings" /></span>
          Send mail template
        </h3>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          @click="closeOffcanva"
        />
      </div>

      <div class="offcanvas-body">
        <div class="mb-1">
          <label
            for=""
            class="form-label"
          >Mail template</label>
          <v-select
            v-model="mail.mail_template_id"
            label="title"
            :clearable="false"
            :options="data"
            :get-option-key="option => option.id"
            :reduce="e => e.id"
          />
        </div>
        <hr>
        <h5>
          <strong>Users ({{ applicants.length }})</strong>
        </h5>
        <table class="table table-stripe">
            <thead>
              <tr>
                <td style="background-color: var(--icrea-brand-bg-light);">
                  Name
                </td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="applicant in applicants" :key="applicant.id">
                <td>{{ applicant.name }}</td>
              </tr>
            </tbody>
          </table>
        
      </div>

      <div class="offcanvas-footer mt-auto">
        <button
          type="button"
          class="btn btn-dark mb-1 d-grid w-100"
          @click="send"
        >
          Send
        </button>
      </div>
    </div>
    <div
      v-if="visible"
      class="offcanvas-backdrop fade"
      :class="{ show: visible }"
      @click="closeOffcanva"
    />
  </div>
  <!-- -->
</template>
<script>
import Vue from 'vue'
import { watch } from 'vue';
import { mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    tableId: {
      type: Number,
      required: false,
      default: null,
    },
    selectedPromotion: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      mail: {
        active: null,
      },
    }
  },
  watch: {
    async selectedPromotion() {
      await this.$store.dispatch('convo/fetchSpecific', this.selectedPromotion)
      await this.$store.dispatch('convo/promotionReport', { promotion_id: this.selectedPromotion, per_page: 1000 })
    }
  },
  computed: {
    ...mapGetters({
      visible: 'modals/sendPromotionResearchers',
      data: 'mailTemplates/items',
      applicants: 'convo/applicants',
    }),
  },
  async mounted() {
    await this.$store.dispatch('mailTemplates/filter', { per_page: 1000 })
  },
  methods: {
    closeOffcanva() {
      this.$store.dispatch('modals/toggleSendPromotionResearchers', false)
    },
    async send() {
      if (this.mail.mail_template_id) {
        Vue.swal({
          title: 'Do you want to send the emails?',
          html: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Yes',
        }).then(async result => {
          if (result.isConfirmed) {
            await this.$store.dispatch('convo/sendPromotionEmails', {
              promotion_id: this.selectedPromotion,
              mail_template_id: this.mail.mail_template_id,
            })
            Vue.swal('', 'Mails send successfully', 'success')
          }
        })
      } else {
        Vue.swal('', 'Please, fill up the mail template field', 'warning')
      }
    },
  },
}
</script>
